
/* ============================== src/api/queries/notifications.js ============================== */
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../client";

export const NOTIFICATIONS_KEY = ["notifications"];

export function useNotificationsQuery(options = {}) {
  return useQuery({
    queryKey: NOTIFICATIONS_KEY,
    queryFn: () => api.get("/notifications"),
    staleTime: 15 * 1000,
    refetchInterval: 60 * 1000,
    ...options,
  });
}

export function useUnreadCountsQuery(options = {}) {
  return useQuery({
    queryKey: ["unread-counts"],
    queryFn: () => api.get("/chat-reads/unread"),
    staleTime: 15 * 1000,
    refetchInterval: 60 * 1000,
    ...options,
  });
}

export function useMarkNotificationReadMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.post(`/notifications/${id}/read`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: NOTIFICATIONS_KEY });
    },
  });
}

export function useMarkAllNotificationsReadMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post("/notifications/read-all"),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: NOTIFICATIONS_KEY });
    },
  });
}
